<template>
   <div class="container-fluid integration-details-container">
      <!-- CHART DESCRIPTION-->
      <div class="chart-description-section">
         <ChartDesc
            v-if="details && details.getStarted && details.getStarted.ctas"
            :chart-title="details.title"
            :chart-desc="details.longDescription"
            :isframeworkvisible="true"
            :get-started-ctas="details.getStarted.ctas"
            :framework="language"
            :show-f-w-name-in-header="false"
         />
      </div>
      <div
         v-if="details.whatCanFE"
         class="chart-description-section-new mt-1"
         v-html="markedRender(details.getExamples.longDescription)"
      />

      <!-- DEMO CHART-->
      <DemoChart
         :details="details"
         :stack="stack"
         :language="language"
         :tab-options="tabOptions"
         :code-view-details="codeViewDetails"
      />

      <!-- <div
         v-if="details.descriptionHeading"
         class="chart-description-section-new mt-3"
         v-html="markedRender(details.descriptionHeading.longDescription)"
      />-->
      <!-- Explore Charts or Features of the Integration-->
      <!-- if span tag is required send props and img tag, anchor are not required send props -->
      <div class="explore-charts-section">
         <ExploreCharts
            v-if="details && details.featureList"
            :chart-data="details.featureList"
            :required-span-tag="true"
            :required-image-tag="false"
            :required-anchor-tag="false"
            :card-behaviour="false"
            fix-padding-top="fix-padding-top"
         />
      </div>

      <!-- Build Charts and Maps -->
      <!-- to adjust height and width of a image send as a prop -->
      <div class="explore-charts-section">
         <ExploreCharts
            v-if="details && details.buildcharts"
            :chart-data="details.buildcharts"
            img-fix="imgfix"
         />
      </div>

      <!-- Explore Dashboards -->
      <!-- cta name can be send as a prop -->
      <div
         class="explore-charts-section"
         :class="{ 'pt-0': !(details && details.exploreDashboards) }"
      >
         <ExploreCharts
            v-if="details && details.exploreDashboards"
            :chart-data="details.exploreDashboards"
            cta-name="see demo"
         />
      </div>
      <!-- GET STARTED -->
      <div class="get-started-section">
         <div class="get-started">
            <h3 class="get-started__header">{{ details.getStarted.header }}</h3>
            <div class="chart-btn pt-3">
               <a
                  class="btn btn-primary-grad chart-btn--grad-custom"
                  :href="details.getStarted.ctas[0].link"
                  @click.prevent="goTo(details.getStarted.ctas[0].link)"
               >
                  {{ details.getStarted.ctas[0].header }}
               </a>
               <a
                  class="btn btn-outline-primary m-0 chart-btn--primary-custom"
                  :href="details.getStarted.ctas[1].link"
                  @click.prevent="goTo(details.getStarted.ctas[1].link)"
               >
                  {{ details.getStarted.ctas[1].header }}
               </a>
            </div>
         </div>
      </div>
      <div
         v-if="details.getDatail"
         class="chart-description-section-new mt-1"
         v-html="markedRender(details.getDatail.longDescription)"
      />
      <!--<Accordion v-if="details.whatCanFE" :config="details.whatCanFE.data" />-->
   </div>
</template>

<script>
import { mapState } from 'vuex';
import DemoChart from '../../components/integrations/DemoChart';
import ExploreCharts from '../../components/integrations/ExploreCharts';
import ChartDesc from '../../components/integrations/ChartDesc';
import metaGenerator from '../../util/meta.js';
// import Accordion from '../../components/pricing/Accordion.vue';

export default {
   name: 'IntegrationDetails',

   components: {
      ChartDesc,
      DemoChart,
      ExploreCharts,
      // Accordion,
   },

   props: {
      stack: {
         type: String,
         default: '',
      },
      language: {
         type: String,
         default: '',
      },
   },

   data() {
      return {
         ...(process.browser && { mixpanelIntegrationsTracker: this.$tracker.Integrations }),
      };
   },
   computed: {
      ...mapState({ details: state => state.integrationsData }),
      tabOptions() {
         const dropDownData = this.details.tabs;
         return dropDownData.map((tab, index) => ({ text: tab.header, value: `${index}` }));
      },
      codeViewDetails() {
         return {
            title: this.details.meta.header,
            description: this.details.meta.description,
         };
      },
   },

   watch: {
      // TODO: need to fix entry-client logic
      $route(to) {
         const [{ props }] = to.matched;
         setTimeout(() => {
            this.$bar.start();
         }, 1000);

         Promise.all([
            this.$store.dispatch('INTEGRATIONS_PAGE_DATA_FETCH', {
               stack: props.default.stack,
               language: props.default.language,
            }),
         ]).then(() => {
            this.$bar.finish();
            this.updateRoute();
            this.storingLocally();
         });
      },
   },

   asyncData({ store, route }) {
      const [{ props }] = route.matched;
      // The route wires up a sideBar slot (client/router.js), but this page
      // never fetched playgroundSidebarData itself - it only ever showed up
      // when a prior page's SPA navigation had already fetched it into the
      // store (PLAYGROUND_SIDEBAR_DATA_FETCH caches it once, sitewide, so
      // it's the same tree everywhere - not page-specific/stale data). A
      // hard refresh starts with an empty store, so the column rendered
      // empty. Fetching it here too, like Explore.vue does, fixes that for
      // both cases instead of just hiding the sidebar.
      store.commit('SET_SIDEBAR_FLAG', {
         data: true,
      });
      return Promise.all([
         store.dispatch('PLAYGROUND_SIDEBAR_DATA_FETCH'),
         store.dispatch('INTEGRATIONS_PAGE_DATA_FETCH', {
            stack: props.default.stack,
            language: props.default.language,
         }),
      ]);
   },

   mounted() {
      this.mixpanelIntegrationsTracker.visited();
      this.updateRoute();
      this.storingLocally();
   },

   methods: {
      goTo(url) {
         const reload = this.$reloadType(url);
         if (!reload) {
            this.$router.push(url).catch(err => {});
         } else {
            window.open(url, '_blank');
         }
      },
      updateRoute() {
         this.$router
            .replace(`${this.$route.path}?framework=${this.details.externalProperties.framework}`)
            .catch(err => {});
      },
      storingLocally() {
         let existingData = localStorage.getItem('userInfo');
         if (existingData === null) {
            existingData = {
               fcTechSelection: this.details.externalProperties.framework,
            };
            localStorage.setItem('userInfo', JSON.stringify(existingData));
         } else {
            existingData = JSON.parse(existingData);
            existingData.fcTechSelection = this.details.externalProperties.framework;
            localStorage.setItem('userInfo', JSON.stringify(existingData));
         }
      },
      goto(e, url, isBlank) {
         if (isBlank) {
            window.open(url, '_blank');
         } else {
            this.$router.push(url).catch(() => {});
         }
      },
   },
   metaInfo() {
      return metaGenerator(this.details);
   },
};
</script>

<style lang="scss" scoped>
.integration-details-container {
   overflow: hidden;
   width: 100%;
   background-color: #f9f9fb;
   padding: 45px 48px 101px;
   @media (max-width: 991px) {
      padding: 30px 30px 101px;
   }
   @media (max-width: 540px) {
      padding: 30px 15px 101px;
   }
   .chart-description-section {
      padding-bottom: 64px;
   }
   .explore-charts-section {
      padding-top: 35px;
   }
   .get-started-section {
      padding-top: 10px;
   }
   .get-started {
      background-color: #ffffff;
      border-radius: 4px;
      box-shadow: 0 8px 10px 0 rgba(62, 57, 107, 0.04);
      padding: 27px 25px;
      &__header {
         line-height: 26px;
         margin-bottom: 1.5rem;
      }
   }
   .chart-btn {
      &--grad-custom,
      &--primary-custom {
         padding: 13px 24px;
         font-size: 15px;
         margin-right: 18px;
         line-height: 16px;
         &:hover {
            box-shadow: 0 4px 6px 0 rgba(50, 50, 93, 0.11);
         }
      }
      &--primary-custom {
         padding: 11.99px 24px;
         @media (max-width: 400px) {
            padding: 11.99px 7px;
            font-size: 13px;
         }
      }
      &--grad-custom {
         @media (max-width: 483px) {
            margin-bottom: 18px;
         }
      }
   }
}
</style>
